export default __webpack_public_path__ + "static/media/dollar-bills-with-wings.95fd7786.svg";